import { render } from "./Contact.vue?vue&type=template&id=7d0f9ff2"
const script = {}
script.render = render

export default script